import styled, { css } from 'styled-components'

export const FormHeader = styled.header`
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    font-size: 20px;
    color: ${({ theme }) => theme.greyishBrown};
    text-align: center;
    margin-bottom: 40px;
    ${({ small }) =>
        small &&
        css`
        font-size: 16px;
        margin-bottom: 10px;
    `
    };
    ${({ alignLeft }) =>
        alignLeft &&
        css`
        text-align: left;
    `
    };
`

export const FormFooter = styled.footer`
    margin-top: 40px;
    ${({ noMargin }) =>
        noMargin &&
        css`
          margin: 0;
        `
    };
`

export const FormBody = styled.div`
    min-width: 260px;
    min-height: ${({ minHeight }) => minHeight ? '190px' : 'auto'};
`

export const FormBodyText = styled.div`
    text-align: center;
    margin-bottom: 45px;
`

export const FormBodyTextHeading = styled.div`
    /* font-weight:  */
    margin-bottom: 25px;
`

export const Icon = styled.svg`
    fill: none;
    stroke: ${({ theme }) => theme.grassyGreen};
    stroke-width: 2px;
`

export const Form = styled.form`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  ${({ fullWidth }) =>
        fullWidth &&
        css`
          max-width: 100%;
        `
    };
`